export default "__VITE_PUBLIC_ASSET__6a00390a__"